import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

const ConfirmationModal = ({ isOpen, onRequestClose, onConfirm, message, isLoading = false, error = null }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={modalStyles}
    >
      <ModalContent>
        <Message>{message}</Message>
        {error && <ErrorText>{error}</ErrorText>}
        <ButtonContainer>
          <Button className='cancel' onClick={onRequestClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button className='confirm' onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Logging out...' : 'Confirm'}
          </Button>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: '300px',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 999999,
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999998,
  },
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Message = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  margin-bottom: 20px;
`;

const ErrorText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #dc3545;
  margin-bottom: 15px;
  font-weight: 500;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  font-family: 'Poppins', sans-serif;
  padding: 10px 20px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  color: white;
  font-size: 12px;
  transition: background-color 0.3s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.cancel {
    background-color: #dc3545;

    &:hover:not(:disabled) {
      background-color: #a02830;
    }
  }

  &.confirm {
    background-color: #000099;

    &:hover:not(:disabled) {
      background-color: #0056b3;
    }
  }
`;

export default ConfirmationModal;
